import React from 'react';

interface StructuredDataProps {
  title: string;
  description: string;
  imageUrl: string;
  url: string;
}

export function StructuredData({ title, description, imageUrl, url }: StructuredDataProps) {
  const structuredData = {
    '@context': 'https://schema.org',
    '@type': 'Product',
    name: title,
    description: description,
    image: imageUrl,
    url: url,
    brand: {
      '@type': 'Brand',
      name: 'Marine Fuel Boost'
    },
    offers: {
      '@type': 'Offer',
      availability: 'https://schema.org/InStock',
      url: url,
      priceValidUntil: new Date(new Date().setFullYear(new Date().getFullYear() + 1)).toISOString().split('T')[0],
      price: '39.99',
      priceCurrency: 'USD'
    },
    category: 'Marine Fuel Additives',
    aggregateRating: {
      '@type': 'AggregateRating',
      ratingValue: '4.8',
      reviewCount: '127'
    },
    additionalProperty: [
      {
        '@type': 'PropertyValue',
        name: 'usage',
        value: 'Marine engines'
      },
      {
        '@type': 'PropertyValue',
        name: 'benefits',
        value: 'Improves fuel efficiency, reduces emissions, extends engine life'
      }
    ]
  };

  return (
    <script
      type="application/ld+json"
      dangerouslySetInnerHTML={{ __html: JSON.stringify(structuredData) }}
    />
  );
}

export function FAQStructuredData({ questions }: { questions: Array<{ question: string; answer: string }> }) {
  const structuredData = {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: questions.map(q => ({
      '@type': 'Question',
      name: q.question,
      acceptedAnswer: {
        '@type': 'Answer',
        text: q.answer
      }
    }))
  };

  return (
    <script
      type="application/ld+json"
      dangerouslySetInnerHTML={{ __html: JSON.stringify(structuredData) }}
    />
  );
} 